jQuery(function ($) {
	// Store the tab elements for easier reference
	const $tabs = $(".sc-tabs-item");
	const $panels = $(".sc-tab-panel");

	// Handle Clicks
	$tabs.on("click", function (e) {
		e.preventDefault();
		activateTab($(this));
	});

	// Handle keyboard navigation
	$tabs.on("keydown", function (e) {
		// Get the index of the current tab
		const $currentTab = $(this);
		const currentIndex = $tabs.index($currentTab);
		const lastIndex = $tabs.length - 1;

		// Handle arrow keys
		switch (e.key) {
			case "ArrowLeft":
			case "Left":
				// Move to the previous tab or wrap to the end
				const prevIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
				$tabs.eq(prevIndex).focus();
				e.preventDefault();
				break;

			case "ArrowRight":
			case "Right":
				// Move to the next tab or wrap to the beginning
				const nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
				$tabs.eq(nextIndex).focus();
				e.preventDefault();
				break;

			case "Home":
				// Move to the first tab
				$tabs.first().focus();
				e.preventDefault();
				break;

			case "End":
				// Move to the last tab
				$tabs.last().focus();
				e.preventDefault();
				break;

			case "Enter":
			case " ":
				// Activate the current tab
				activateTab($currentTab);
				e.preventDefault();
				break;
		}
	});

	// Function to update URL with tab parameter
	function updateUrlWithTab(tabName) {
		// Get the current URL
		const url = new URL(window.location.href);

		// Extract the tab identifier from the target class
		const tabParam = tabName.replace("sc-site-section--", "");

		// Set the tab parameter
		url.searchParams.set("tab", tabParam);

		// Update the URL without reloading the page
		window.history.pushState({}, "", url);
	}

	// Function to activate a tab
	function activateTab($tab) {
		// Deactivate all tabs
		$tabs.removeClass("active")
			.attr("aria-selected", "false")
			.attr("tabindex", "-1");

		// Activate the selected tab
		$tab.addClass("active")
			.attr("aria-selected", "true")
			.attr("tabindex", "0");

		// Hide all panels
		$panels.removeClass("active")
			.attr("hidden", "hidden");

		// Show the selected panel
		const targetId = $tab.data("target");
		$("." + targetId)
			.addClass("active")
			.removeAttr("hidden");

		// Update URL with the tab parameter
		updateUrlWithTab(targetId);
	}

	// Function to check URL for tab parameter and activate corresponding tab
	function checkUrlForTab() {
		const url = new URL(window.location.href);
		const tabParam = url.searchParams.get("tab");

		if (tabParam) {
			// Find the tab that corresponds to the parameter
			const targetClass = "sc-site-section--" + tabParam;
			const $targetTab = $tabs.filter(`[data-target="${targetClass}"]`);

			// If we found a matching tab, activate it
			if ($targetTab.length) {
				activateTab($targetTab);
				return;
			}
		}
	}

	// Set initial tabindex values
	$tabs.attr("tabindex", "-1");
	$tabs.filter(".active").attr("tabindex", "0");

	// Hide non-active panels with the hidden attribute
	$panels.not(".active").attr("hidden", "hidden");

	// Check URL for tab parameter on page load
	checkUrlForTab();
});
